import React, { useEffect } from 'react';
import { Typography, Box, Grid, Button, TextField, Pagination, CircularProgress, Dialog, DialogContent, DialogActions, DialogTitle, Snackbar, FormControlLabel, Switch, MenuItem, Select, FormControl, InputLabel, FormHelperText } from "@mui/material";
import { green } from '@mui/material/colors';
import MuiAlert from '@mui/material/Alert';
import TableInfo from '../../components/TableInfo';
import Add from '@mui/icons-material/Add'

import * as yup from 'yup';
import { useFormik } from 'formik';

import api, { baseURL } from '../../services/api';

export default function Certidoes() {
    const [loadingFile, setLoadingFile] = React.useState(false);
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [dialogEditOpen, setDialogEditOpen] = React.useState(false);
    const [editingDocument, setEditingDocument] = React.useState(null);
    const [listFiles, setListFiles] = React.useState([])
    const [sendindDocument, setSendingDocument] = React.useState(false)
    const [stateAlert, setStateAlert] = React.useState({ status: false, type: 'success', msg: '' });
    const [loading, setLoading] = React.useState(true)
    const [page, setPage] = React.useState(1);
    const [pageCount, setPageCount] = React.useState(1);
    const pageSize = 10;
    const columns = [
        { Header: "Arquivo", accessor: "title", width: "100%" },
        { Header: "Files", accessor: "actions", width: "90%" },
    ];

    const validationDocument = yup.object({
        title: yup
            .string('Insira o nome do Arquivo')
            .required('Campo necessário'),
        file: yup
            .mixed()
            .nullable(),
        link: yup
            .string()
            .nullable()
            .url('Insira um link válido'),
        publishSite: yup
            .boolean(),
        type: yup
            .string('Selecione o tipo de documento')
            .oneOf(['certidoes', 'declaracao'], 'Tipo inválido')
            .required('Campo necessário'),
    })

    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    async function handleCertificate(event) {
        const files = event.target.files
        const formData = new FormData()
        formData.append('files', files[0])
        setLoadingFile(true)
        try {
            const doc = await api.post('/upload', formData)
            if (dialogEditOpen) {
                formDocumentEdit.setFieldValue(event.target.name, doc.data[0].id)
            } else {
                formDocument.setFieldValue(event.target.name, doc.data[0].id)
            }
            setStateAlert({ ...stateAlert, status: true, type: 'success', msg: `Arquivo enviado com sucesso` })
            setLoadingFile(false)
        } catch (error) {
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: 'Erro ao enviar!' })
            setLoadingFile(false)
        }
    };

    const formDocument = useFormik({
        initialValues: { title: '', file: null, link: null, publishSite: false, type: '' },
        validateOnMount: true,
        validationSchema: validationDocument,
        enableReinitialize: true,
        onSubmit: (values) => {
            sendData(values)
        },
    });

    const formDocumentEdit = useFormik({
        initialValues: { title: '', file: null, link: '', publishSite: false, type: '' },
        validateOnMount: true,
        validationSchema: validationDocument,
        enableReinitialize: true,
        onSubmit: (values) => {
            updateData(values)
        },
    });

    async function sendData(values) {
        try {
            setSendingDocument(true)
            const documentSaved = await api.post('/documents', { data: values })
            if (documentSaved.status === 200) {
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: 'Documento salvo com sucesso' })
                setSendingDocument(false)
                await handleFiles()
                formDocument.handleReset()
                setDialogOpen(false)
            }
        } catch (error) {
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `${error.message}` })
            setSendingDocument(false)
        }
    }

    async function handleDelete({ id }) {
        try {
            const deleteFile = await api.delete('/documents/' + id)
            if (deleteFile.status === 200) {
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: `Documento excluído com sucesso` })
                await handleFiles()
            }
        } catch (error) {
            console.log(error)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `${error.message}` })
        }
    }

    async function handleView({ id }) {
        try {
            const link = listFiles.find(file => id == file.id)?.attributes?.link;
            if(link) {
                window.open(link, '_blank');
                return; 
            }
            const [files] = listFiles.filter(file => id == file.id)
            if(files.attributes?.file?.data?.attributes?.url !== null) {
                window.open(`${baseURL + files.attributes.file.data.attributes.url}`, '_blank');
            }
        } catch (error) {
            console.log(error)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `${error.message}` })
        }
    }

    async function handleEdit({ id }) {
        try {
            const document = listFiles.find(file => file.id === id);
            if (document) {
                setEditingDocument(document);
                formDocumentEdit.setValues({
                    title: document.attributes.title || '',
                    file: document.attributes.file?.data?.id || null,
                    link: document.attributes.link || '',
                    publishSite: document.attributes.publishSite || false,
                    type: document.attributes.type || ''
                });
                setDialogEditOpen(true);
            }
        } catch (error) {
            console.log(error)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `${error.message}` })
        }
    }

    async function updateData(values) {
        try {
            setSendingDocument(true)
            const documentUpdated = await api.put(`/documents/${editingDocument.id}`, { data: values })
            if (documentUpdated.status === 200) {
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: 'Documento atualizado com sucesso' })
                setSendingDocument(false)
                await handleFiles(page)
                formDocumentEdit.handleReset()
                setDialogEditOpen(false)
                setEditingDocument(null)
            }
        } catch (error) {
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `${error.message}` })
            setSendingDocument(false)
        }
    }

    async function handleFiles(pageNumber = 1) {
        try {
            const files = await api.get(`/documents?populate=*&pagination[page]=${pageNumber}&pagination[pageSize]=${pageSize}&sort=title:asc`);
            if (files.status === 200) {
                setListFiles(files.data.data);
                setPage(files.data.meta.pagination.page);
                setPageCount(files.data.meta.pagination.pageCount);
                setLoading(false);
            }
        } catch (error) {
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `${error.message}` })
            setLoading(false)
        }
    }

    useEffect(() => { handleFiles(1) }, [])

    return (
        <Box sx={{ width: '100%', height: '100vh' }} p={5}>
            <Grid container px={12} sx={{ justifyContent: 'space-between' }}>
                <Grid item xs={3}>
                    <Typography variant='h4'>Cadastro de Certidões</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Button variant="contained" onClick={() => setDialogOpen(true)} startIcon={<Add />}>Adicionar Documento</Button>
                </Grid>
            </Grid>
            <Snackbar
                open={stateAlert.status}
                autoHideDuration={2500}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                onClose={() => setStateAlert({ status: false, type: 'success', msg: '' })} >
                <Alert sx={{ width: '100%' }} severity={`${stateAlert.type}`}>
                    {stateAlert.msg}
                </Alert>
            </Snackbar>
            <Dialog
                open={dialogOpen}
                maxWidth={'lg'}
                aria-describedby="edit-dialog" >
                <DialogTitle>{"Adicionar Certidão"}</DialogTitle>
                <form onSubmit={formDocument.handleSubmit}>
                    <DialogContent>
                        <Grid container spacing={2} columns={12} sx={{ justifyContent: 'center' }}>
                            <Grid item xs={12}>
                                <TextField sx={{ width: '100%' }}
                                    label="Titulo da certidão"
                                    id='title'
                                    name="title"
                                    variant="outlined"
                                    value={formDocument.values.title}
                                    onChange={formDocument.handleChange}
                                    error={formDocument.touched.title && Boolean(formDocument.errors.title)}
                                    helperText={formDocument.touched.title && formDocument.errors.title}
                                    placeholder="Titulo da certidão"
                                />
                            </Grid>
                            <Grid item xs={10}>
                                <Box sx={{ m: 1, position: 'relative' }}>
                                    <Button variant="contained" component="label" fullWidth disabled={loadingFile} >
                                        Adicionar Arquivo
                                        <input
                                            hidden
                                            name="file"
                                            type={'file'}
                                            accept={".png, .jpg, .jpeg, .pdf, .docx, .doc"}
                                            label="Adicionar Arquivo"
                                            onChange={(e) => handleCertificate(e)}
                                            error={formDocument.touched.file && Boolean(formDocument.errors.file)}
                                            helperText={formDocument.touched.file && formDocument.errors.file}
                                            sx={{ width: '100%' }}
                                            variant="outlined"
                                        />
                                    </Button>
                                    {loadingFile && (
                                        <CircularProgress
                                            size={24}
                                            sx={{
                                                color: green[500],
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                marginTop: '-12px',
                                                marginLeft: '-12px',
                                            }}
                                        />
                                    )}
                                </Box>
                                <Typography variant='caption'>{!!formDocument.values.file ? 'Documento Enviado' : ''}</Typography>
                                <Typography variant='caption' color={"#FF0000"}>{formDocument.errors.file}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    sx={{ width: '100%' }}
                                    label="Link do documento (opcional)"
                                    id="link"
                                    name="link"
                                    variant="outlined"
                                    value={formDocument.values.link}
                                    onChange={formDocument.handleChange}
                                    error={formDocument.touched.link && Boolean(formDocument.errors.link)}
                                    helperText={formDocument.touched.link && formDocument.errors.link}
                                    placeholder="https://exemplo.com/documento.pdf"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth variant="outlined" error={formDocument.touched.type && Boolean(formDocument.errors.type)}>
                                    <InputLabel id="type-label">Tipo de Documento</InputLabel>
                                    <Select
                                        labelId="type-label"
                                        id="type"
                                        name="type"
                                        value={formDocument.values.type}
                                        onChange={formDocument.handleChange}
                                        label="Tipo de Documento"
                                    >
                                        <MenuItem value="certidoes">Certidões</MenuItem>
                                        <MenuItem value="declaracao">Declaração</MenuItem>
                                    </Select>
                                    {formDocument.touched.type && formDocument.errors.type && (
                                        <FormHelperText>{formDocument.errors.type}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            id="publishSite"
                                            name="publishSite"
                                            checked={formDocument.values.publishSite}
                                            onChange={formDocument.handleChange}
                                            color="primary"
                                        />
                                    }
                                    label="Publicar no Site"
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button variant='outlined' onClick={() => { setDialogOpen(false); formDocument.handleReset() }} color="error">Cancelar</Button>
                        <Box sx={{ m: 1, position: 'relative' }}>
                            <Button variant="contained" color='success' type={'submit'} fullWidth disabled={sendindDocument}>Salvar</Button>
                            {sendindDocument && (
                                <CircularProgress
                                    size={24}
                                    sx={{
                                        color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                    }}
                                />
                            )}
                        </Box>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                open={dialogEditOpen}
                maxWidth={'lg'}
                aria-describedby="edit-dialog" >
                <DialogTitle>{"Editar Certidão"}</DialogTitle>
                <form onSubmit={formDocumentEdit.handleSubmit}>
                    <DialogContent>
                        <Grid container spacing={2} columns={12} sx={{ justifyContent: 'center' }}>
                            <Grid item xs={12}>
                                <TextField sx={{ width: '100%' }}
                                    label="Titulo da certidão"
                                    id='title'
                                    name="title"
                                    variant="outlined"
                                    value={formDocumentEdit.values.title}
                                    onChange={formDocumentEdit.handleChange}
                                    error={formDocumentEdit.touched.title && Boolean(formDocumentEdit.errors.title)}
                                    helperText={formDocumentEdit.touched.title && formDocumentEdit.errors.title}
                                    placeholder="Titulo da certidão"
                                />
                            </Grid>
                            <Grid item xs={10}>
                                <Box sx={{ m: 1, position: 'relative' }}>
                                    <Button variant="contained" component="label" fullWidth disabled={loadingFile} >
                                        {formDocumentEdit.values.file ? 'Alterar Arquivo' : 'Adicionar Arquivo'}
                                        <input
                                            hidden
                                            name="file"
                                            type={'file'}
                                            accept={".png, .jpg, .jpeg, .pdf, .docx, .doc"}
                                            label="Adicionar Arquivo"
                                            onChange={(e) => handleCertificate(e)}
                                            error={formDocumentEdit.touched.file && Boolean(formDocumentEdit.errors.file)}
                                            helperText={formDocumentEdit.touched.file && formDocumentEdit.errors.file}
                                            sx={{ width: '100%' }}
                                            variant="outlined"
                                        />
                                    </Button>
                                    {loadingFile && (
                                        <CircularProgress
                                            size={24}
                                            sx={{
                                                color: green[500],
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                marginTop: '-12px',
                                                marginLeft: '-12px',
                                            }}
                                        />
                                    )}
                                </Box>
                                <Typography variant='caption'>{!!formDocumentEdit.values.file ? 'Documento Enviado' : ''}</Typography>
                                <Typography variant='caption' color={"#FF0000"}>{formDocumentEdit.errors.file}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    sx={{ width: '100%' }}
                                    label="Link do documento (opcional)"
                                    id="link"
                                    name="link"
                                    variant="outlined"
                                    value={formDocumentEdit.values.link}
                                    onChange={formDocumentEdit.handleChange}
                                    error={formDocumentEdit.touched.link && Boolean(formDocumentEdit.errors.link)}
                                    helperText={formDocumentEdit.touched.link && formDocumentEdit.errors.link}
                                    placeholder="https://exemplo.com/documento.pdf"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth variant="outlined" error={formDocumentEdit.touched.type && Boolean(formDocumentEdit.errors.type)}>
                                    <InputLabel id="type-label-edit">Tipo de Documento</InputLabel>
                                    <Select
                                        labelId="type-label-edit"
                                        id="type"
                                        name="type"
                                        value={formDocumentEdit.values.type}
                                        onChange={formDocumentEdit.handleChange}
                                        label="Tipo de Documento"
                                    >
                                        <MenuItem value="certidoes">Certidões</MenuItem>
                                        <MenuItem value="declaracao">Declaração</MenuItem>
                                    </Select>
                                    {formDocumentEdit.touched.type && formDocumentEdit.errors.type && (
                                        <FormHelperText>{formDocumentEdit.errors.type}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            id="publishSite"
                                            name="publishSite"
                                            checked={formDocumentEdit.values.publishSite}
                                            onChange={formDocumentEdit.handleChange}
                                            color="primary"
                                        />
                                    }
                                    label="Publicar no Site"
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button variant='outlined' onClick={() => { setDialogEditOpen(false); formDocumentEdit.handleReset(); setEditingDocument(null); }} color="error">Cancelar</Button>
                        <Box sx={{ m: 1, position: 'relative' }}>
                            <Button variant="contained" color='success' type={'submit'} fullWidth disabled={sendindDocument}>Salvar</Button>
                            {sendindDocument && (
                                <CircularProgress
                                    size={24}
                                    sx={{
                                        color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                    }}
                                />
                            )}
                        </Box>
                    </DialogActions>
                </form>
            </Dialog>
            <Grid container p={3}>
                {loading ?
                    <Box sx={{ width: '100%', height: '10vh', display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress sx={{ alignSelf: 'center' }} size={50} />
                    </Box>
                    :
                    <>
                        <TableInfo title='Certidões' variant="secondary" deactive={handleDelete} view={handleView} edit={handleEdit} rows={listFiles} columns={columns} />
                        <Grid container justifyContent="center" sx={{ mt: 2 }}>
                            <Pagination
                                count={pageCount}
                                page={page}
                                onChange={(e, value) => {
                                    setPage(value)
                                    handleFiles(value)
                                }
                                }
                                color="primary"
                            />
                        </Grid>
                    </>
                }
            </Grid>

        </Box>
    )
}